<!-- 标题 -->
<template>
  <div class="title-container">
    <div class="title"
      >{{ (data && data.que_title) || ''
      }}<span class="checkbox-flag" v-if="data.que_type == 1"
        >（多选）</span
      ></div
    >
    <div class="title-desc" v-if="descData.type == 'text'">{{
      descData.text
    }}</div>
    <QuestionImage v-if="descData.type == 'image'" :url="descData.url" />
  </div>
</template>
<script>
import QuestionImage from './q-image.vue'
export default {
  components: {
    QuestionImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    descData() {
      this.data.que_introduce = this.data.que_introduce || ''
      if (typeof this.data.que_introduce == 'string') {
        return {
          type: 'text',
          text: this.data.que_introduce
        }
      }
      return {
        type: this.data.que_introduce.type || 'text',
        text: this.data.que_introduce.text || '',
        url: this.data.que_introduce.url || ''
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.title-container {
  margin-bottom: 38px;
}
.title {
  display: inline-block;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #27243c;
  line-height: 32px;
  margin-bottom: 4px;

  .checkbox-flag {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #27243c;
    line-height: 17px;
  }
}

.title-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(5, 11, 39, 0.5);
  line-height: 17px;
}
</style>
